import { ChangeDetectionStrategy, Component, computed, inject, input, model, signal } from '@angular/core';
import { IconComponent } from '@shared/lib/components/ui/icon/icon.component';
import { ModalComponent } from '@shared/lib/components/ui/modal/modal.component';
import { isNullOrEmpty } from '@shared/lib/core/utils/data-validation.util';
import { CoreModule } from '@shared/lib/modules/core.module';
import { DeploymentStore } from '@shared/lib/stores/deployment.store';
import { OdsLoaderComponent } from '@web-app/app/dialogs/ods-loader/ods-loader.component';
import { SingleSelectComponent } from '@web-app/app/dialogs/single-select/single-select.component';
import { DeploymentsApi } from '@web-app/app/services/api/deployments.api';
import { ButtonDirective } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { Message } from 'primeng/message';

@Component({
    selector: 'ods-modal-tenant-deployment',
    templateUrl: './tenant-deployment.component.html',
  imports: [CoreModule, SingleSelectComponent, OdsLoaderComponent, ModalComponent, SkeletonModule, ButtonDirective, IconComponent, Message],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TenantDeploymentComponent {
  protected deploymentStore = inject(DeploymentStore);
  protected deploymentsApi = inject(DeploymentsApi);
  isLoading = signal(false);
  isVisible = model.required<boolean>();
  requireDeployment = input<boolean>(false);
  headerText = computed(() => {
    let header = 'Select ';
    if (isNullOrEmpty(this.deploymentStore.selectedTenantId())) {
      header += ' tenant';
    }
    if (this.requireDeployment()) {
      if (isNullOrEmpty(this.deploymentStore.selectedDeploymentId())) {
        header += ' & deployment';
      }
    }
    return header;
  });

  hideModal() {
    this.isVisible.set(false);
  }

  reloadData() {
    this.deploymentsApi.getDeploymentTree(this.deploymentStore.selectedTenantId() ?? 0).subscribe(deployments => {
      this.deploymentStore.setDeploymentList(deployments);
    })
  }
}
